import { z } from 'zod/v4'
import { useMesaDynamicConfig } from '@/src/services/Statsig/useMesaDynamicConfig'

export const RewardsControlSchema = z.object({
  'Gift Cards': z.object({
    enabled: z.boolean(),
    buttons: z.object({
      "Lowe's": z.boolean(),
      Amazon: z.boolean(),
      Airbnb: z.boolean(),
      'View More': z.boolean(),
    }),
  }),
  'Statement Credit': z.object({
    enabled: z.boolean(),
    buttons: z.object({
      'Redeem $20': z.boolean(),
      'Redeem $50': z.boolean(),
      'Custom Amount': z.boolean(),
    }),
  }),
  'More Rewards': z.object({
    enabled: z.boolean(),
    buttons: z.object({
      Mortgage: z.boolean(),
      Omni: z.boolean(),
      'Book Travel': z.boolean(),
      'Points Transfer': z.boolean(),
    }),
  }),
}) satisfies z.ZodType<Record<string, { enabled: boolean; buttons: Record<string, boolean> }>>

export type RewardsControl = z.infer<typeof RewardsControlSchema>

export function useRewardsControlDynamicConfig() {
  return useMesaDynamicConfig('rewards_control')
}
